import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import WishToaster from "./WishToaster";

const DuplicateResolutionGuard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isPending = localStorage.getItem("duplicate_resolution_pending") === "1";

    if (isPending && location.pathname !== "/") {
      WishToaster({
        toastType: "error",
        toastMessage: "Please resolve your duplicate phone/email to continue.",
      });
      navigate("/", { replace: true });
    }
  }, [location.pathname, navigate]);

  return children;
};

export default DuplicateResolutionGuard;
